import HandsonTableComponent from "../../../components/handsonTable/handsonTable";
import { connect } from "react-redux";
import each from "lodash/each";
import columnCustomizer from "./columnCustomizer";
import { isEmpty } from "lodash/lang";

const MAX_ROWS_TO_FILTER = 25000;
export default connect((state) => {
  const { tableInfo, ...rawDataTable } = state.rawDataTable;
  const columns = tableInfo.columns || [];
  const { tableConfiguration: { linkColumns = [] } = {} } = tableInfo;
  const customizedColumns = columnCustomizer(tableInfo.colHeaders, columns, linkColumns)
  const hiddenColumns = {
    columns: []
  };
  let colHeaders = tableInfo.colHeaders;
  let isManyColumns = !isEmpty(tableInfo.data) && tableInfo.data.length > 99999 && true;

  each(linkColumns, (colName) => {
    const colIndex = tableInfo.colHeaders.indexOf(colName);
    colHeaders = colHeaders.splice(0);
    colHeaders.splice(colIndex + 1, 0, `${colName} url`);
    customizedColumns.splice(colIndex + 1, 0, `{ type: "text" }`);
    hiddenColumns.columns.push(colIndex + 1);
  });

  return {
    showExportFileButton: true,
    showExportCSV: true,
    data: tableInfo.data,
    colHeaders,
    rowHeaders: true,
    hiddenColumns,
    columns: customizedColumns,
    rowHeaderWidth: isManyColumns && 70,
    fragmentSelection: true,
    columnSorting: true,
    filters: tableInfo.data?.length <= MAX_ROWS_TO_FILTER,
    stretchH: "all",
    dropdownMenu:
      tableInfo.data?.length > 1 && tableInfo.data?.length <= MAX_ROWS_TO_FILTER
        ? [
            "filter_by_condition", //
            "---------",
            "filter_by_value",
            "filter_action_bar"
          ]
        : false,
    colWidths: tableInfo.colWidths,
    showCloseWindowButton: rawDataTable.currentUser.showCloseWindowButton,
    showViewAllDataButton: rawDataTable.currentUser.showViewAllDataButton,
    showViewAllDataUrl: rawDataTable.currentUser.showViewAllDataUrl,
    showSharedMembersDataButton: rawDataTable.currentUser.showSharedMembersDataButton,
    showSharedMembersUrl: rawDataTable.currentUser.showSharedMembersUrl,
    hideSharedMembersDataButton: rawDataTable.currentUser.hideSharedMembersDataButton,
    hideSharedMembersUrl: rawDataTable.currentUser.hideSharedMembersUrl,
    showViewSummaryButton: rawDataTable.currentUser.showViewSummaryButton,
    showViewSummaryUrl: rawDataTable.currentUser.showViewSummaryUrl,
    showViewBackButton: rawDataTable.currentUser.showViewBackButton,
    showViewBackUrl: rawDataTable.currentUser.showViewBackUrl,
    headerInfo: rawDataTable.headerInfo,
    labelInfo: rawDataTable.labelInfo
  };
})(HandsonTableComponent);
